import DIApi from './_diApi';

class BudgetItemDetailAPI extends DIApi {
  controllerName = 'BudgetItemDetails';
}

export default new BudgetItemDetailAPI();
